import { makeAutoObservable, runInAction } from "mobx";
import { baseUrl, access_key } from "./main";

export default class NewsStore {
  news = [];
  allNewsCount = "";
  error = false;
  isLoading = false;
  newsPerPage = 3;
  page = 1;

  selectedNews;

  constructor(instance) {
    this.rootStore = instance;
    makeAutoObservable(this, {}, { deep: true });
  }

  getNewsData = async () => {
    this.isLoading = true;
    this.page = 1;
    this.news = [];

    let bodyData = new FormData();
    bodyData.append("access_key", access_key);
    bodyData.append("status", "published");
    bodyData.append("page", this.page);
    bodyData.append("on_page", this.newsPerPage);
    bodyData.append("order", "time_create");
    bodyData.append("ordered", "DESC");

    return fetch(`${baseUrl}/crm/massrecruitment/api/getdata?action=news`, {
      method: "POST",
      body: bodyData
    })
      .then((response) => {
        if (response.ok) {
          return response.json();
        } else {
          runInAction(() => {
            this.error = true;
            this.isLoading = false;
          });
        }
      })
      .then((response) => {
        runInAction(() => {
          if (response["records"] !== "-1") {
            this.news = response["records"];
            this.allnews = response["count_all"];
          }
          this.isLoading = false;
        });
      })
      .catch(() => {
        runInAction(() => {
          this.error = true;
          this.isLoading = false;
        });
      });
  };

  showMoreNews = async () => {
    this.isLoading = true;
    this.page = this.page + 1;

    let bodyData = new FormData();
    bodyData.append("access_key", access_key);
    bodyData.append("status", "published");
    bodyData.append("page", this.page);
    bodyData.append("on_page", this.newsPerPage);
    bodyData.append("order", "time_create");
    bodyData.append("ordered", "DESC");

    return fetch(`${baseUrl}/crm/massrecruitment/api/getdata?action=news`, {
      method: "POST",
      body: bodyData
    })
      .then((response) => {
        if (response.ok) {
          return response.json();
        } else {
          runInAction(() => {
            this.error = true;
            this.isLoading = false;
          });
        }
      })
      .then((response) => {
        runInAction(() => {
          if (response["records"] !== "-1") {
            this.news = [...this.news, ...response["records"]];
            this.allNewsCount = response["count_all"];
          }
          this.isLoading = false;
        });
      })
      .catch(() => {
        runInAction(() => {
          this.error = true;
          this.isLoading = false;
        });
      });
  };

  getOneNews = async (id) => {
    this.isLoading = true;

    let bodyData = new FormData();
    bodyData.append("access_key", access_key);
    bodyData.append("status", "published");
    bodyData.append("page", 1);
    bodyData.append("on_page", 1000);
    bodyData.append("order", "time_create");
    bodyData.append("ordered", "DESC");

    return fetch(`${baseUrl}/crm/massrecruitment/api/getdata?action=news`, {
      method: "POST",
      body: bodyData
    })
      .then((response) => {
        if (response.ok) {
          return response.json();
        } else {
          runInAction(() => {
            this.error = true;
            this.isLoading = false;
          });
        }
      })
      .then((response) => {
        runInAction(() => {
          if (response["records"] !== "-1") {
            response["records"].forEach((item) => {
              if (item["id"] === id) {
                this.selectedNews = item;
              }
            });
          }
          this.isLoading = false;
        });
      })
      .catch(() => {
        runInAction(() => {
          this.error = true;
          this.isLoading = false;
        });
      });
  };
}
